import { ChartTooltipV2 } from '@Components/Charts/ChartTooltip/ChartTooltipV2';
import { getFormattedValue } from '@Components/NumberFormatter/NumberFormatter';
import { PacingDetailSeries, SERIES_PAIRS } from '../pacing-constants';
import { NON_MONETARY_GOALS, isPacingRatioGoalType } from '../pacingUtils';

interface PacingTooltipProps {
  active?: boolean;
  // recharts injects the hovered points; each carries `dataKey` and the row `payload`.
  payload?: { dataKey?: string; payload: Record<string, number> }[];
  label?: string;
  goalName?: string;
}

export const PacingTooltip = ({ active, payload, label, goalName = '' }: PacingTooltipProps) => {
  const hovered = payload?.[0];
  const match = SERIES_PAIRS.find(([, keys]) => keys.some(key => key === hovered?.dataKey));
  if (!active || !hovered || !match) {
    return null;
  }

  const [phase, [actualKey, idealKey]] = match;
  const type = NON_MONETARY_GOALS.includes(goalName) ? '#2' : '$';
  const seriesItem = (itemLabel: string, key: typeof actualKey | typeof idealKey) => ({
    label: itemLabel,
    value: getFormattedValue({ value: hovered.payload[key], type }),
    color: PacingDetailSeries[key].color,
    keyShape: PacingDetailSeries[key].shape
  });

  return (
    <ChartTooltipV2
      headers={[(label ?? '').replace(/-/g, '/')]}
      subHeaderLabel={phase}
      items={[
        seriesItem('Actual Delivery', actualKey),
        ...(isPacingRatioGoalType(goalName) ? [] : [seriesItem('Ideal Delivery', idealKey)])
      ]}
    />
  );
};
